import React, { Component } from 'react';

class Image extends Component {

  constructor(props) {
    super()
    this.props = props
  }

  render() {
    return (
      <div className={`image-wrapper image-wrapper--${this.props.className}`}>
        <img src={this.props.imageData.url} className={`image image--${this.props.className}`}/>
      </div>  
    )
  }
}

export default Image;



/** WEBPACK FOOTER **
 ** ./src/js/components/image/index.js
 **/